document.addEventListener("DOMContentLoaded", () => {
  class ProductReviews extends HTMLElement {
    constructor() {
      super();
    console.log('called')

      this.pageSize = parseInt(window.reviewPageSize) || 5;
      this.currentPage = 1;
      this.totalPages = 1;
    }

    connectedCallback() {
      const id = window.reviewComponentId;

      this.reviewsList = this.querySelector(`.ai-reviews-list-${id}`);
      if (!this.reviewsList) return;

      this.cards = Array.from(this.querySelectorAll(`.ai-review-card-${id}`));

      const reviewData = window.productReviews;
      if (reviewData && reviewData.reviews && Array.isArray(reviewData.reviews.value)) {
        this.totalReviews = reviewData.reviews.value.length;
      } else if (reviewData && reviewData.reviews && Array.isArray(reviewData.reviews)) {
        this.totalReviews = reviewData.reviews.length;
      } else {
        this.totalReviews = 0;
      }

      this.totalPages = Math.ceil(this.totalReviews / this.pageSize);

      this.prevButton = this.querySelector('[data-action="prev"]');
      this.nextButton = this.querySelector('[data-action="next"]');
      this.currentPageSpan = this.querySelector('[data-current-page]');
      this.totalPagesSpan = this.querySelector('[data-total-pages]');

      if (this.totalPagesSpan) {
        this.totalPagesSpan.textContent = this.totalPages;
      }

      this.setupEventListeners();
      this.showPage(1);
    }

    setupEventListeners() {
      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => this.goToPage(this.currentPage - 1));
      }

      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => this.goToPage(this.currentPage + 1));
      }
    }

    goToPage(pageNumber) {
      if (pageNumber < 1 || pageNumber > this.totalPages) return;
      this.showPage(pageNumber);
      this.scrollToTop();
    }

    showPage(pageNumber) {
      const id = window.reviewComponentId;

      this.currentPage = pageNumber;

      const startIndex = (pageNumber - 1) * this.pageSize;
      const endIndex = startIndex + this.pageSize;

      this.cards.forEach((card, index) => {
        card.style.display = index >= startIndex && index < endIndex ? "flex" : "none";
      });

      if (this.currentPageSpan) this.currentPageSpan.textContent = pageNumber;
      if (this.prevButton) this.prevButton.disabled = pageNumber === 1;
      if (this.nextButton) this.nextButton.disabled = pageNumber === this.totalPages;
    }

    scrollToTop() {
      const id = window.reviewComponentId;
      const target = this.querySelector(`.ai-reviews-grid-${id}`);
      if (target) {      
        this.scrollIntoView({
          behavior: 'smooth',
          block: 'start',    // aligns to the top of the container
          inline: 'nearest'
        });     
      }
    }
  }

  if (!customElements.get("product-reviews")) {
    customElements.define("product-reviews", ProductReviews);
  }
});
